import { render } from "./history.vue?vue&type=template&id=5a24d9b6&ts=true"
import script from "./history.vue?vue&type=script&lang=ts&config=true"
export * from "./history.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__